import React from 'react'
import { FormGroup, FormControlLabel, Switch, Grid } from '@mui/material'

/**
 * Toggle component for switching between card and list views in marketplace
 */
const MarketplaceViewToggle = ({ showMenu, onToggle  }) => {
  return (
    <Grid data-hf-grid="keep" size={12}>
      {!showMenu && (
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                style={{ marginRight: 100 }}
                onClick={onToggle}
                size="small"
                defaultChecked
              />
            }
            label="Show Menu"
          />
        </FormGroup>
      )}
    </Grid>
  );
}

export default MarketplaceViewToggle
